<template>
  <base-modal
    :reference="'edit_stop_hour_' + stop.id"
    :title="'Editar hora de paso'"
    :acceptAction="acceptAction"
    :cancelActionText="'Cerrar'"
  >
    <template v-slot:body>
      <form>
        <div class="d-flex justify-content-center w-100">
          <div class="d-flex flex-column align-items-sm-baseline">
            <label>Hora</label>
              <b-form-input
                type="time"
                v-model="form.stopHour"
                placeholder="Inserte hora de recogida del guía"
                style="width: 17vw;"
              ></b-form-input>
          </div>
        </div>
      </form>
    </template>
  </base-modal>
</template>

<script>
/* eslint-disable */

import BaseModal from "./BaseModal";

export default {
  components: {
    BaseModal,
  },
  props: {
    stop: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        stopHour: this.stop.hora,
      },
    };
  },
  async mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      const current = "edit_stop_hour_" + this.stop.id;
      if (modalId == current) {
      }
    });
  },
  methods: {
    async acceptAction() {
      
      let payload = {
        id: this.stop.id,
        data: {
          hour: this.form.stopHour
        }
      }
      this.$store.dispatch("stops/changeHour", payload);
      this.$store.dispatch("buses/busesPath");

      this.$bvModal.hide("edit_stop_hour_" + this.stop.id);
      this.$notify({
        group: "foo",
        title: "Hora de parada editada",
        text: "Se ha editado la hora de paso de la parada",
        type: "success",
      });
    },
    
  },
};
</script>